// extracted by mini-css-extract-plugin
module.exports = {"divider":"Link_divider__6eCJQ","item":"Link_item__3GtuA","link":"Link_link__FfF0a"};